import React from "react";
import "../styles/my-assets-liability.scss";

function ConfirmModal({ show, onConfirm, onCancel, loading, title, message, yesLabel = "Yes", noLabel = "No" }) {
  if (!show) return null;
  return (
    <div className="custom-modal-backdrop">
      <div className="custom-modal-content">
        <h5>{title}</h5>
        <p>{message}</p>
        <div className="custom-modal-footer">
          <button className="btn btn-secondary" onClick={onCancel} disabled={loading}>{noLabel}</button>
          <button className="btn btn-danger" onClick={onConfirm} disabled={loading}>
            {loading ? 'Deleting...' : yesLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
